import React from 'react';
import { func, string, bool, shape, arrayOf } from 'prop-types';

import Forms from 'components/form-react-elements';

const Sorting = ({ disabled, onChange, selectedSorting = '', sorting }) => {
    if (!sorting || !sorting.options || !sorting.options.length) {
        return null;
    }

    return (
        <div className="listing-sorting">
            <Forms.Select
                disabled={disabled}
                flatBottom
                inlineLabel
                label={sorting.label}
                labelIsBold
                name={sorting.id}
                noBorder
                onChange={onChange}
                options={sorting.options}
                placeholder={sorting.placeholder}
                small
                value={selectedSorting}
            />
        </div>
    );
};

Sorting.propTypes = {
    disabled: bool,
    onChange: func,
    selectedSorting: string,
    sorting: shape({
        id: string,
        value: string,
        label: string,
        type: string,
        disabled: bool,
        placeholder: string,
        options: arrayOf(
            shape({
                label: string,
                value: string
            })
        )
    }).isRequired
};

export default Sorting;
